import CharacterCounter from '../../../ui/CharacterCounter'

interface ProductNameFieldProps {
  value: string
  onChange: (value: string) => void
  labelWidth?: number
}

const MAX_LENGTH = 50

const styles: Record<string, React.CSSProperties> = ({
  formGroup: {
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    fontWeight: 'bold',
    fontSize: '16px',
    marginBottom: '4px',
    pointerEvents: 'none',
    flexShrink: 0,
    marginRight: '8px',
  },
  required: {
    color: '#e74c3c',
    marginLeft: '4px',
  },
  inputContainer: {
    flex: 1,
    position: 'relative',
  },
  input: {
    width: '100%',
    padding: '10px 45px 10px 10px',
    fontSize: '16px',
    border: '1px solid #ddd',
    borderRadius: '4px',
  },
  counter: {
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
  },
})

const ProductNameField: React.FC<ProductNameFieldProps> = ({
  value,
  onChange,
}) => {
  return (
    <div style={styles.formGroup}>
      <label style={styles.label}>
        商品名<span style={styles.required}>*</span>
      </label>
      <div style={styles.inputContainer}>
        <input
          type="text"
          value={value}
          onChange={(e) => {
            const newValue = e.target.value
            if (newValue.length <= MAX_LENGTH) {
              onChange(newValue)
            }
          }}
          placeholder="特製のり弁当"
          style={styles.input}
          maxLength={MAX_LENGTH}
          required
        />
        <div style={styles.counter}>
          <CharacterCounter currentLength={value.length} maxLength={MAX_LENGTH} />
        </div>
      </div>
    </div>
  )
}

export default ProductNameField
